// removed by extract-text-webpack-plugin
module.exports = {"deleteWindow":"DeleteConfirmation__deleteWindow__21sqa","deleteTitle":"DeleteConfirmation__deleteTitle__3VO0x","form":"DeleteConfirmation__form__ecT-u"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DeleteConfirmation/DeleteConfirmation.css
// module id = 480
// module chunks = 0